import { CanDeactivateFn } from '@angular/router';

export interface PendingChangesAware {
  /**
   * Indica si el componente mantiene cambios locales todavía no persistidos.
   */
  hasUnsavedChanges(): boolean;

  /**
   * Solicita confirmación al usuario antes de descartar cambios pendientes.
   */
  confirmDiscardChanges(): boolean;

  /**
   * Revierte el estado local al último estado persistido.
   */
  discardUnsavedChanges(): void;
}

/**
 * Evita abandonar una ruta si el componente expone cambios sin guardar.
 * Si el usuario confirma la salida, se descartan los cambios locales.
 */
export const pendingChangesGuard: CanDeactivateFn<PendingChangesAware> = (component) => {
  if (!component.hasUnsavedChanges()) {
    return true;
  }

  const shouldDiscard = component.confirmDiscardChanges();

  if (shouldDiscard) {
    component.discardUnsavedChanges();
  }

  return shouldDiscard;
};
